module.exports = __webpack_public_path__ + "assets/img/1531587607769_.pic_hd.0e01ac6f.jpg";